import React from 'react';

import {
    withInterstitial,
} from 'wanderu-component-page-loader';
import { Redirect as AppRedirect } from 'wanderu-component-react-router-link';

const POLICY_PAGES = [
    'terms-and-conditions',
    'privacy-policy',
    'cookie-policy',
];

const AppPage = withInterstitial(import('./pages/TermsAndConditions'), {
    onLoad(module, ...args) {
        module.onLoad(module, ...args);
    },
});

export default [
    {
        path: `/:policy(${POLICY_PAGES.join('|')})/`,
        exact: true,
        component: AppPage,
        key: 'legal-pages',
    },
    {
        path: `/:policy(${POLICY_PAGES.join('|')})/*`,
        key: 'legal-pages-catchall',
        component: ({ match }) => {
            const { policy } = match.params;

            return (
                <AppRedirect href={`/${policy}/`} />
            );
        },
    },
];
